<script>
  import resources from './resources'
  export default {
    name: 'overview',
    mixins: [resources]
  }
</script>

<template lang="pug">
div
  loading(
    :active.sync="loading",
    :can-cancel="false",
    :is-full-page="fullPage",
    color="#7159c1"
  )
  .modal-backdrop(v-if="isShowActive")
    .modal(
      style="z-index: 1040; padding-right: 15px; display: block;",
      aria-modal="true",
      v-show="isShowActive",
      :class="{ 'modal-mobile': isMobiled }"
    )
      .modal-dialog(role="document")
        .modal-content
          .modal-header
            h4#defaultModalLabel.title Confirmação de agendamento
          .modal-body
            ative-code(:schedule="selectedSchedule")
          .modal-footer
            button.btn.btn-simple.btn-round.waves-effect(
              @click.prevent="doHide()",
              type="button"
            ) Fechar

  .body.m-b-5.l-green(v-for="schedule in schedules")
    .event-name.row
      .col-3.text-center
        h4
          | {{ dtDay(schedule.dt) }}
          span {{ dtMonth(schedule.dt) }}
          span {{ dtYear(schedule.dt) }}
      .col-9
        h6 {{ schedule.event_name }}
        p {{ schedule.title }}
        address
          i.zmdi.zmdi-pin
          |
          | {{ schedule.area.name }}
          br
          span(v-if="schedule.area.charge_for_hours === 'true'")
            | {{ formatTime(schedule.dt) }}
          i.zmdi.zmdi-flip.cursor-pointer(
            v-if="schedule.confirmed === 'false' && schedule.area.charge_for_hours !== 'true'",
            style="float: right;font-size: 16px;",
            @click.prevent="doActive(schedule)"
          )

          i.zmdi.zmdi-delete.cursor-pointer(
            @click.prevent="doDelete(schedule)",
            style="float: right;font-size: 16px;"
          )
</template>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/nexts/next.vue